import { render, staticRenderFns } from "./onboardingPackageDetails.vue?vue&type=template&id=add1a11e&"
import script from "./onboardingPackageDetails.vue?vue&type=script&lang=js&"
export * from "./onboardingPackageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports